import { Component } from '@theme/component';

/**
 * Fixed product bar shown once the page's purchase button scrolls out of view.
 * Works on any product template: it observes the element matched by `data-target`.
 * @extends {Component}
 */
class StickyProductBar extends Component {
  #controller;
  #observer;

  connectedCallback() { super.connectedCallback(); this.#bind(); }
  updatedCallback() { super.updatedCallback(); this.#bind(); }
  disconnectedCallback() {
    this.#controller?.abort();
    this.#observer?.disconnect();
    super.disconnectedCallback();
  }

  #bind() {
    this.#controller?.abort();
    this.#observer?.disconnect();
    this.#controller = new AbortController();
    const target = document.querySelector(this.dataset.target || '');
    if (!(target instanceof HTMLElement)) {
      this.hidden = true;
      return;
    }
    this.#observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (!entry) return;
      this.hidden = entry.isIntersecting || entry.boundingClientRect.top >= 0;
    });
    this.#observer.observe(target);
    this.querySelector('[data-sticky-action]')?.addEventListener('click', () => {
      if (this.dataset.action === 'add') {
        target.click();
        return;
      }
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
    }, { signal: this.#controller.signal });
  }
}
if (!customElements.get('sticky-product-bar')) customElements.define('sticky-product-bar', StickyProductBar);
